import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const SECRETARY_POST_REQUEST = 'POST_SECRETARY_REQUEST';
export const SECRETARY_POST_FAILURE = 'POST_SECRETARY_FAILURE';
export const SECRETARY_POST_SUCCESS = 'POST_SECRETARY_SUCCESS';

export const postSecretary = (data) => {
    return function(dispatch) {
        dispatch(postRequest());
        return axios(apiRequestOptions(apiPath.SECRETARY.POST, data))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(postSuccess(response.data));
                dispatch(addSuccessMessage('Secretary successfully added'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postRequest = () => {
    return { type: SECRETARY_POST_REQUEST }
};

const postFailure = error => {
    return { type: SECRETARY_POST_FAILURE, error }
};

const postSuccess = secretary => {
    return { type: SECRETARY_POST_SUCCESS, secretary }
};